import * as React from 'react'
import { ReactElement, SVGProps } from 'react'
import AssistChip from './chips/AssistChip'
import { twMerge } from 'tailwind-merge'

interface IconWrapperProps
  extends Omit<React.SVGProps<SVGSVGElement>, 'ref' | 'onClick'>,
    React.RefAttributes<SVGSVGElement> {
  /**
   * icon component
   */
  Icon: (props: SVGProps<SVGSVGElement>) => ReactElement
  /**
   * icon size (will set both width and height)
   */
  size?: string | number
  /**
   * icon color
   */
  color?: string

  bgColor?: string
  type?: 'default' | 'chip' | 'colored-circle'
  onClick?: () => void
}

/**
 * Generic wrapper to be used anywhere you need an icon
 */
export const IconWrapper = ({
  Icon,
  size = 24,
  color,
  type = 'default',
  className,
  bgColor,
  ...props
}: IconWrapperProps) => (
  <div>
    {type === 'chip' ? (
      <AssistChip squared onPress={props.onClick} className={className}>
        <Icon width={size} height={size} color={color} />
      </AssistChip>
    ) : type === 'colored-circle' ? (
      <div
        style={{
          width: Number(size) + Number(size) + 'px',
          height: Number(size) + Number(size) + 'px'
        }}
        className={twMerge(
          twMerge(
            'mix-blend-multiply text-brand-600 rounded-full flex items-center justify-center',
            bgColor ? bgColor : 'bg-brand-100'
          ),
          className
        )}>
        <Icon width={size} height={size} color={color} {...props} />
      </div>
    ) : (
      <Icon width={size} height={size} color={color} {...props} />
    )}
  </div>
)
